import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getObjectFromLocalStore, removeLocalStore } from "../utils/localStore";
import { resetLoginState, resetLogoutState, setFCMToken } from "app/redux";
import { clearSessionStore } from "app/utils/sessionStore";
import { AutoLogoutProps, USERTYPE } from "app/utils/types";

const SESSION_IDLE_MINUTES = process.env.REACT_APP_LOGOUT_IDLE_MINUTES;
const SESSION_IDLE_MINUTES_CONTACT = process.env.REACT_APP_LOGOUT_IDLE_MINUTES_CONTACT;

// Falls back when the env var is missing or non-numeric. Without this the
// timeout is NaN and react-idle-timer never fires, so the session never ends.
const DEFAULT_IDLE_MINUTES = 60;

const resolveIdleMinutes = (value?: string) => {
  const minutes = Number(value);
  return Number.isFinite(minutes) && minutes > 0 ? minutes : DEFAULT_IDLE_MINUTES;
};

const AutoLogoutTimer = ({ ComposedClass }: any) => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const userAccess = getObjectFromLocalStore("useraccess");

  const handleOnIdle = () => {
    removeLocalStore("useraccess");
    removeLocalStore("assistantAgentUserAccess");
    clearSessionStore();
    dispatch(resetLogoutState());
    dispatch(resetLoginState());
    dispatch(setFCMToken(false));
    nav("/", { replace: true });
  };

  useIdleTimer({
    timeout:
      1000 *
      60 *
      resolveIdleMinutes(
        userAccess?.userType === USERTYPE.CONTACT
          ? SESSION_IDLE_MINUTES_CONTACT
          : SESSION_IDLE_MINUTES,
      ),
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return <ComposedClass />;
};

function areEqual(prevProps: Readonly<AutoLogoutProps>, nextProps: Readonly<AutoLogoutProps>) {
  if (prevProps?.location?.pathname === nextProps?.location?.pathname) {
    return true;
  }
  return false;
  /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */
}

export default React.memo(AutoLogoutTimer, areEqual);
